import styled from "styled-components";

export const StyledBannerIconImage = styled.img`
    width: 24px;
    height: 24px;
`;
